import { render, staticRenderFns } from "./PayFor5k.vue?vue&type=template&id=909a7212&scoped=true&"
import script from "./PayFor5k.vue?vue&type=script&lang=js&"
export * from "./PayFor5k.vue?vue&type=script&lang=js&"
import style0 from "./PayFor5k.vue?vue&type=style&index=0&id=909a7212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909a7212",
  null
  
)

export default component.exports